import { Link } from "react-router-dom";
import { Instagram, Heart, MapPin, Phone, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { getWhatsAppUrl, WHATSAPP_DISPLAY } from "@/config/contact";

export default function Footer() {
  return (
    <footer className="bg-petal-olive-text text-petal-beige-alt">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <Logo className="h-14" testId="footer-logo" />
            </div>
            <p className="font-dancing text-petal-gold text-lg mb-4">Made with love,<br />wrapped with happiness</p>
            <p className="font-outfit text-sm text-petal-border/80 leading-relaxed">
              Handcrafted gifts for every occasion. Every bouquet tells a story — let us be a part of yours.
            </p>
            <div className="flex gap-3 mt-6">
              <a href="https://www.instagram.com/petal_pookie.08" target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 border border-petal-gold/40 flex items-center justify-center text-petal-gold hover:bg-petal-gold hover:text-petal-olive-text transition-colors" data-testid="footer-instagram">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-outfit text-xs uppercase tracking-[0.2em] text-petal-gold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {[{to:"/",l:"Home"},{to:"/shop",l:"Shop All"},{to:"/about",l:"About Us"},{to:"/cart",l:"Cart"}].map(({to,l}) => (
                <li key={to}><Link to={to} className="font-outfit text-sm text-petal-border/80 hover:text-petal-gold transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          {/* Occasions */}
          <div>
            <h3 className="font-outfit text-xs uppercase tracking-[0.2em] text-petal-gold mb-6">Occasions</h3>
            <ul className="space-y-3">
              {["Birthday", "Anniversary", "Wedding", "Valentine's Day"].map(occ => (
                <li key={occ}>
                  <Link to={`/shop?occasion=${encodeURIComponent(occ)}`} className="font-outfit text-sm text-petal-border/80 hover:text-petal-gold transition-colors">{occ}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-outfit text-xs uppercase tracking-[0.2em] text-petal-gold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-petal-gold mt-0.5 shrink-0" />
                <a href={getWhatsAppUrl()} className="font-outfit text-sm text-petal-border/80 hover:text-petal-gold transition-colors">{WHATSAPP_DISPLAY}</a>
              </li>
              <li className="flex items-start gap-3">
                <Instagram className="w-4 h-4 text-petal-gold mt-0.5 shrink-0" />
                <a href="https://www.instagram.com/petal_pookie.08" target="_blank" rel="noopener noreferrer"
                  className="font-outfit text-sm text-petal-border/80 hover:text-petal-gold transition-colors">Petal Pookie</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-petal-border/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-outfit text-xs text-petal-border/50">© 2026 Petal Pookie. All rights reserved.</p>
          <p className="font-outfit text-xs text-petal-border/50 flex items-center gap-1">
            Made with <Heart className="w-3 h-3 text-petal-gold inline" /> by<Link to="https://tahirjamal.com" target="_blank" rel="noopener noreferrer" className="text-petal-gold hover:text-petal-gold/80 transition-colors"> Tahir Jamal</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
